import { useLazyQuery } from '@apollo/client';
import { exportXlsModal } from 'motion-components';
import { gqlGetQuery } from '../graphql';
import { buildWhereFromFilterValues } from './filters';
import { useState } from 'react';
//export columns for the route
export const exportColumns = (t) => {
  return [
    { fieldName: 'id', fieldTitle: t('ID'), fieldType: 'TEXT' },
    { fieldName: 'code', fieldTitle: t('Κωδικός Δρομολογίου'), fieldType: 'TEXT' },
    { fieldName: 'driver.name', fieldTitle: t('Οδηγός'), fieldType: 'TEXT' },
    { fieldName: 'vehicle.collector.name', fieldTitle: t('Συλλέκτης'), fieldType: 'TEXT' },
    { fieldName: 'vehicle.plateNumber', fieldTitle: t('Όχημα'), fieldType: 'TEXT' },
    { fieldName: 'routeDate', fieldTitle: t('Ημερομηνία Δρομολόγησης'), fieldType: 'DATE' },
  ];
};

export async function handleExport(client, queryState: any, t): Promise<void> {
  function useGetQuery() {
    const [get, { loading }] = useLazyQuery(gqlGetQuery, {
      onCompleted: transformData,
      fetchPolicy: 'network-only',
    });
    const [result, setResult] = useState<any>([get, { loading, data: undefined }]);
    function transformData(data) {
      console.log('data transform', data);
      const recs = data.getRoutes.data.map((values) => {
        return {
          ...values,
        };
      });
      const trsData = {
        getRoutes: { data: recs, recordCount: data?.getRoutes?.recordCount },
      };
      setResult([get, { loading, data: trsData }]);
    }
    return result;
    //return [null, { loading: null, data: null }];
  }
  const filterVariables = {
    where: buildWhereFromFilterValues(queryState?.filterValues),
  };
  await exportXlsModal({
    apolloClient: client,
    exportFileName: 'Routes',
    getLazyQuery: useGetQuery,
    columnsDef: exportColumns(t),
    filterVariables: filterVariables,
  });
}
